import React from 'react'
import { Layout } from 'antd'
import { Outlet } from 'react-router-dom'

const { Content } = Layout

const AuthLayout = () => {
  return (
    <Layout>
      <Content
        style={{
          overflowX: 'hidden',
          overflowY: 'scroll',
          padding: '8px',
        }}
      >
        <Outlet />
      </Content>
    </Layout>
  )
}

export default AuthLayout
